import styled from "@emotion/styled";
import { useCallback, useEffect, useRef, useState } from "react";
import * as React from "react";

import { Button, Checkbox, FormField, Input, Modal } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import Flex from "components/layout/Flex";
import { compose, maxLength, required } from "utils/validators";

interface IProps {
  name: string;
  onSave: (name: string, shared?: boolean) => void;
  onCancel: () => void;
  shared: boolean;
  isAdmin: boolean;
}

const nameValidator = compose(required("Name is required"), maxLength("Name is too long (max 1024 characters)", 1024));

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const EditModal = ({ name, shared, isAdmin, onSave, onCancel }: IProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [nameInputValue, setNameInputValue] = useState(name);
  const [sharedInputValue, setSharedInputValue] = useState(shared);

  const error = nameValidator(nameInputValue, {});

  const handleNameChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setNameInputValue(e.target.value);
  }, []);

  const handleSharedChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSharedInputValue(e.target.checked);
  }, []);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleSave = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!error) {
      onSave(nameInputValue, isAdmin ? sharedInputValue : undefined);
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <form onSubmit={handleSave}>
      <Modal
        onClose={onCancel}
        style={{ width: "600px", maxHeight: "90%" }}
        heading="Edit view"
        footer={
          <Flex>
            <Block marginRight="8px">
              <Button kind="secondary" size="large" type="button" onClick={onCancel}>
                Cancel
              </Button>
            </Block>
            <Button kind="primary" size="large" disabled={!!error} type="submit">
              Save
            </Button>
          </Flex>
        }
      >
        <FormField labelText="Ticket view name">
          <FullWidthInputField
            id="custom-view-new-name"
            ref={inputRef}
            autoFocus
            value={nameInputValue}
            onChange={handleNameChange}
            error={!!error}
            data-testid="custom-view-new-name"
            data-1p-ignore
          />
        </FormField>
        {isAdmin && (
          <Checkbox
            id="is-shared"
            checked={sharedInputValue}
            description="All team members will have access to this view"
            onChange={handleSharedChange}
          >
            Shared view
          </Checkbox>
        )}
      </Modal>
    </form>
  );
};

const FullWidthInputField = styled(Input)`
  input {
    width: 100%;
  }
`;

export default EditModal;
